import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const IdeasIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 16, height = 16, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_3949_125)">
          <path
            d="M1.5 8H2.22222M8 1.5V2.22222M13.7778 8H14.5M3.37778 3.37778L3.88333 3.88333M12.6222 3.37778L12.1167 3.88333M6.33889 11.6111H9.66111M5.83333 10.8889C5.22701 10.4341 4.77913 9.80015 4.55315 9.07672C4.32716 8.35328 4.33453 7.57708 4.5742 6.85807C4.81387 6.13905 5.2737 5.51367 5.88855 5.07051C6.50339 4.62736 7.24209 4.38889 8 4.38889C8.75791 4.38889 9.49661 4.62736 10.1115 5.07051C10.7263 5.51367 11.1861 6.13905 11.4258 6.85807C11.6655 7.57708 11.6728 8.35328 11.4469 9.07672C11.2209 9.80015 10.773 10.4341 10.1667 10.8889C9.88469 11.168 9.67238 11.5096 9.54691 11.886C9.42144 12.2624 9.38634 12.6631 9.44444 13.0556C9.44444 13.4386 9.29226 13.806 9.02138 14.0769C8.75049 14.3478 8.38309 14.5 8 14.5C7.61691 14.5 7.24951 14.3478 6.97862 14.0769C6.70774 13.806 6.55556 13.4386 6.55556 13.0556C6.61366 12.6631 6.57856 12.2624 6.45309 11.886C6.32762 11.5096 6.11531 11.168 5.83333 10.8889Z"
            stroke="#5D708C"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_3949_125">
            <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
